import { orchestrator } from 'satcheljs';
import { getPremiumUser } from '../services/getPremiumUser';
import setPremiumUserState from '../mutators/setPremiumUserState';
import { getPremiumUser as getPremiumUserAction } from '../actions/getPremiumUser';

export default orchestrator(getPremiumUserAction, async function getPremiumUserAction() {
    let response = await getPremiumUser();
    setPremiumUserState(response);
});
